import m from "../../geodata/es2015/cambodiaLow";
window.am4geodata_cambodiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/cambodiaLow.js
// module id = null
// module chunks = 